<template>
	<div class="calculator">
		<div class="calculator__range-wrap">
			<step-widget
			:title="'сумма инвестирования'"
			:minRange="10000"
			:maxRange="1000000"
			:stepRange="10000"
			:metric="'$'"
			:defaultValue="10000"
			@getData = "setSumInvesting($event)"></step-widget>
			<step-widget
			:title="'СРОК ИНВЕСТИРОВАНИЯ'"
			:minRange="1"
			:maxRange="36"
			:stepRange="1"
			:metric="'мес.'"
			@getData = "setPeriodInvesting($event)"></step-widget>
			<step-widget
			:title="'КРЕДИТНОЕ ПЛЕЧО'"
			:minRange="1"
			:maxRange="100"
			:stepRange="1"
			@getData = "setBrokerLeverage($event)"></step-widget>
		</div>
		<div v-if="!dataReady" class="calculator__range-wrap">
		<div class="calculator__range-item calculator__range-item-sum">
			<div class="calculator__range-item-wrap">
				<div class="calculator__range-item-title">Доход</div>
				<div class="calculator__range-item-data calculator__range-item-data-sum">
					<div class="calculator__result">$ {{(Math.ceil(profit)).toLocaleString('en')}}</div>
					<div class="calculator__profit-wrap">
						<div class="calculator__profit">+ {{Math.ceil(profitPercent)}} % </div>
					</div>
				</div>
			</div>
		</div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import RangeWidget from './sig-calculator-change-step-widget'

	export default {
		components: {
	       'step-widget':RangeWidget
	    },
		props: [],
		data() {
			return {
                stat:[],
                sumInvesting:10000,
                periodInvesting:30,
                brokerLeverage:1,
                symbol:''
			};
		},
		computed: {
            ...mapGetters ({
                getStat:'accountstat/getStatistics'
            }),
			profit(){
                if(this.stat.length === 0)
                    return 0
                return (this.sumInvesting * (1+(this.stat.Summary.Twr/100)*this.periodInvesting/929))*this.brokerLeverage/this.stat.Summary.MaxLeverage
            },
            profitPercent() {
                return 100/(this.sumInvesting/this.profit)
            },
            getDays() {
                let n = new Date();
                let endDate = new Date(n.setMonth(n.getMonth() + this.periodInvesting));
                let timeDiff = endDate.getTime() - n.getTime();
                let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
                return `${endDate} - ${n};`
            },
            dataReady()
            {
                if (!this.stat || !this.stat.length) return false;
                return true;
            }
		},
		methods: {
            setSumInvesting(value)
            {
                this.sumInvesting = value;
            },
            setPeriodInvesting(value)
            {
                this.periodInvesting = value*30
            },
            setBrokerLeverage(value)
            {
                this.brokerLeverage = value
            },
            updateStatistics(symbol)
            {
                let stat = this.getStat(this.symbol);
                if (!stat) {
                    return;
                }
                this.stat = stat;
            }
        },
        created() {
          //this.stat = this.$store.getters['accountstat/getCroppedStatBySymbol']('')
          subscribeOnUpdate(this.$store, '', isFirstObtained => {
                this.updateStatistics()
          });
            this.updateStatistics()
        }
    };
    function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "calculator",
            handler: handler
        }
    });
}
</script>

<style lang="less" scoped>
.calculator {
	height: calc(100vh - 220px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: #3d536b;
    &__result {
        font-family: Montserrat;
        font-size: 92px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: 1.3px;
        text-align: left;
        color: #ffffff;
    }

    &__profit {
        font-family: Montserrat;
        font-size: 44px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: 0.4px;
        text-align: left;
        color: #00ffd0;
    }

    &-title {
        font-family: Montserrat;
        font-size: 23px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.09;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-top: 40px;
        color: #ffffff;
    }

    &__range-wrap {
        width: 912px;
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
    }

    &__range-item {
        &-sum {
            width: 100%;
            display: block;
        }
        &-wrap {
            border-radius: 4px;
            background-color: #3d536b;
            padding: 1px;
            box-sizing: border-box;
        }

        &-title {
            font-family: Montserrat;
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.43;
            letter-spacing: 0.4px;
            text-align: center;
            color: #adc7e1;
            text-transform: uppercase
        }

        &-data {
            border-radius: 4px;
            background-color: #293546;
            width: 100%;
            &-sum {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 40px;
                box-sizing: border-box;
            }
        }
    }
}
</style>
